import { useTranslate } from '@refinedev/core';
import { Card, Progress, Typography, theme } from 'antd';

const { Text, Paragraph } = Typography;

interface SearchPopularityCardProps {
  /** `search_popularity`, on the API's 0-10 scale. */
  value?: number | null;
  /** Defaults to the copy shared by every user_catalog resource. */
  title?: string;
  description?: string;
}

export const SearchPopularityCard = ({
  value,
  title,
  description,
}: SearchPopularityCardProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const score = value ?? 0;
  const heading = title ?? t('user_catalog.common.show.search.title');
  const body = description ?? t('user_catalog.common.show.search.description');

  return (
    <Card>
      <div style={{ maxWidth: 640 }}>
        <Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
          {heading}
        </Text>
        <div
          style={{
            fontSize: token.fontSizeHeading1,
            lineHeight: token.lineHeightHeading1,
            fontWeight: token.fontWeightStrong,
            marginTop: token.marginXXS,
          }}
        >
          {score}{' '}
          <Text
            type="secondary"
            style={{ fontSize: token.fontSizeHeading4, fontWeight: 400 }}
          >
            / 10
          </Text>
        </div>
        <Progress
          percent={score * 10}
          showInfo={false}
          style={{ marginTop: token.margin }}
        />
        <Paragraph
          type="secondary"
          style={{ marginTop: token.margin, marginBottom: 0 }}
        >
          {body}
        </Paragraph>
      </div>
    </Card>
  );
};
